module.exports = __webpack_public_path__ + "img/saum_moosgruen_ral6005.42b091ed.jpg";